import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { TYPE } from '../../theme/tokens';

// ---------------------------------------------------------------------------
// Lista pliabilă.
//
// Rândurile stau într-o singură coloană, despărțite de o linie de 1px, fără
// chenar propriu și fără umbră: nu sunt patru cartonașe suprapuse, e o listă.
// Fiecare rând are 60px, adică o țintă de atingere confortabilă și pe telefon.
//
// Detaliile se lățesc până la 70 de caractere pe rând și nu mai departe —
// dincolo de atât, ochiul pierde începutul rândului următor.
// ---------------------------------------------------------------------------
export default function Disclosure({ items = [], onDark = false, sx }) {
  const ink = onDark ? 'var(--qf-deep-ink)' : 'var(--qf-ink)';
  const ink2 = onDark ? 'var(--qf-deep-ink-2)' : 'var(--qf-ink-2)';
  const line = onDark ? 'var(--qf-deep-line)' : 'var(--qf-line)';

  return (
    <Box sx={sx}>
      {items.map((item, i) => (
        <Accordion
          key={item.title || i}
          sx={{
            borderTopColor: line,
            color: ink,
            '&:first-of-type': { borderTop: 'none' },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ fontSize: 24, color: onDark ? 'rgba(255,255,255,.6)' : undefined }} />}
            aria-label={item.title}
          >
            <Typography
              component="span"
              sx={{ ...TYPE.body, fontWeight: 500, color: ink, pr: 1, textWrap: 'pretty' }}
            >
              {item.title}
            </Typography>
          </AccordionSummary>

          <AccordionDetails>
            {(Array.isArray(item.details) ? item.details : [item.details])
              .filter(Boolean)
              .map((detail, j) => (
                <Typography
                  key={j}
                  component="p"
                  sx={{
                    ...TYPE.small,
                    color: ink2,
                    m: 0,
                    mt: j === 0 ? 0 : 1.25,
                    textWrap: 'pretty',
                  }}
                >
                  {detail}
                </Typography>
              ))}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
}
